class CatalogCard extends HTMLElement {
  constructor() {
    super();
    this.images = Array.from(this.querySelectorAll('.catalog-card__slide'));
    this.prevButton = this.querySelector('.catalog-card__arrow--prev');
    this.nextButton = this.querySelector('.catalog-card__arrow--next');
    this.arrowsUsed = false;

    this.activeIndex = parseInt(this.dataset.startIndex, 10) || 0;
    this.showIndex(this.activeIndex);

    if (this.prevButton) {
      this.prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.arrowsUsed = true;
        this.step(-1);
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.arrowsUsed = true;
        this.step(1);
      });
    }

    if (this.images.length > 1 && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', () => {
        if (this.arrowsUsed) return;
        this.hoverIndex = (this.activeIndex + 1) % this.images.length;
        this.showIndex(this.hoverIndex, true);
      });

      this.addEventListener('mouseleave', () => {
        if (this.arrowsUsed) return;
        this.showIndex(this.activeIndex, true);
      });
    }
  }

  step(direction) {
    if (this.images.length === 0) return;
    this.activeIndex = (this.activeIndex + direction + this.images.length) % this.images.length;
    this.showIndex(this.activeIndex);
  }

  showIndex(index, isPreview = false) {
    this.images.forEach((image, i) => {
      image.classList.toggle('is-active', i === index);
    });
    if (!isPreview) this.activeIndex = index;
  }
}

customElements.define('catalog-card', CatalogCard);
